import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionItem {
  title: string;
  content: React.ReactNode;
}
interface AccordionProps {
  items: AccordionItem[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-3" data-id="element-13">
      {items.map((item, index) => <div key={index} className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden" data-id="element-14">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors" data-id="element-15">
            <span className="font-semibold text-gray-900" data-id="element-16">{item.title}</span>
            <ChevronDown className={`w-5 h-5 text-gray-600 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-17" />
          </button>
          {openIndex === index && <div className="p-4 pt-0 text-gray-700 border-t border-gray-100" data-id="element-18">
              {item.content}
            </div>}
        </div>)}
    </div>;
}